// Defers Sketchfab iframe creation until the embed scrolls near the viewport, so WebXR
// is not initialized on page load (bfcache) and the ~4.6MB model isn't fetched unless seen.
class Model3DEmbed extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.load();
          this.observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    this.observer.observe(this);
  }

  load() {
    if (this.loaded) return;
    this.loaded = true;

    const src = this.dataset.src;
    if (!src) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'model-3d__iframe';
    iframe.src = src;
    iframe.title = this.dataset.title || '3D Model';
    iframe.allow = 'autoplay; fullscreen; xr-spatial-tracking';
    iframe.allowFullscreen = true;

    this.appendChild(iframe);
  }
}

customElements.define('model-3d-embed', Model3DEmbed);
